import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import roleService from "../../services/roleService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const roleFormSchema = [
  {
    name: "roleName",
    label: "Role Name",
    type: "text",
    placeholder: "e.g. Manager",
    validation: { required: true },
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function RoleCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await roleService.createRole(values);
      alertService.success("Role created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Role">
      <CrudForm
        mode="create"
        schema={roleFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default RoleCreateModal;
